module.exports = __webpack_public_path__ + "img/card5-bl3.f364e760.svg";